// extracted by mini-css-extract-plugin
module.exports = {"content":"content___SwgdA","container":"container___2iGXJ","logoContainer":"logoContainer___1U5LC","details":"details___1Ec3K"};